/**
 * HelpCenterSection Component
 * Knowledge base, support, and live chat options
 */

import { Button } from "@/components/ui/button"
import { useTranslation } from "@/language"

const SUPPORT_OPTIONS = (t: (key: string) => string) => [
  {
    title: t("helpCenter.knowledgeBase"),
    description: t("helpCenter.knowledgeBaseDesc"),
    action: t("helpCenter.knowledgeBase"),
    variant: "primary" as const,
  },
  {
    title: t("helpCenter.getSupport"),
    description: t("helpCenter.getSupportDesc"),
    action: t("helpCenter.messageSupport"),
    variant: "primary" as const,
  },
  {
    title: t("helpCenter.liveChat"),
    description: t("helpCenter.liveChatDesc"),
    action: t("helpCenter.chatNow"),
    variant: "primary" as const,
  },
]

export function HelpCenterSection() {
  const { t } = useTranslation("settings")
  const supportOptions = SUPPORT_OPTIONS(t)

  const handleAction = (_action: string) => {
    // TODO: Implement support action handlers
  }

  return (
    <div className="flex flex-col gap-8">
      {/* Section Header */}
      <div>
        <h1 className="text-2xl font-bold text-charcoal uppercase section-heading">
          {t("helpCenter.title")}
        </h1>
        <p className="text-sm text-stone mt-1">{t("helpCenter.description")}</p>
      </div>

      <div className="flex flex-col gap-4">
        {supportOptions.map(option => (
          <div
            key={option.title}
            className="flex items-start justify-between gap-4 py-5 rounded-xl border-0"
          >
            <div className="flex items-start gap-4">
              <div>
                <h3 className="text-sm font-semibold text-charcoal">{option.title}</h3>
                <p className="text-sm text-stone mt-1">{option.description}</p>
              </div>
            </div>
            <Button
              variant={option.variant}
              size="sm"
              onClick={() => handleAction(option.action)}
              className="shrink-0"
            >
              {option.action}
            </Button>
          </div>
        ))}
      </div>

      {/* Resources Link */}
      <button
        type="button"
        className="flex items-center gap-2 text-sm font-medium text-body transition-colors cursor-pointer self-start"
      >
        {t("helpCenter.resourcesLink")}
      </button>
    </div>
  )
}
